export const ticketQueue = {
  name: "Ticket Queue |||| Ticket Queues",
  fields: {
    name: "Name",
    description: "Description",
    color: "Color",
    isDefault: "Default Queue",
    greetingMessage: "Greeting Message",
    outOfHoursMessage: "Out of Hours Message",
    schedules: "Business Hours",
  },
  none: "No queue",
  default: "Default",
  noQueues: "No queues available",
  errors: {
    CANNOT_DELETE_DEFAULT_QUEUE:
      "Cannot delete the default queue. Set another queue as default first.",
    CANNOT_DELETE_LAST_QUEUE:
      "Cannot delete the only remaining queue. At least one queue must exist.",
    CANNOT_DELETE_QUEUE_WITH_ACTIVE_TICKETS:
      "Cannot delete queue with %{activeTicketsCount} active ticket(s). Reassign or close them first.",
    CANNOT_UNSET_DEFAULT_QUEUE:
      "Cannot unset the default queue. Set another queue as default first.",
    deleteFailed: "Failed to delete queue",
    updateFailed: "Failed to update queue",
  },
};
